module.exports = __webpack_public_path__ + "static/assets/44ef836f327ccbeff19f7aa0ba7157ed.svg";